import { Compass } from 'lucide-react';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-white/80">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 py-10">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-accent text-white flex items-center justify-center">
              <Compass size={16} />
            </div>
            <div>
              <p className="font-serif text-base">Truffle Hunting Oregon</p>
              <p className="text-[10px] uppercase tracking-widest text-ink-light">Oregon travel guide</p>
            </div>
          </div>

          <nav className="flex flex-wrap gap-6 text-sm text-ink-light">
            <a href="/privacy.html" className="hover:text-accent transition-colors">Privacy</a>
            <a href="/terms.html" className="hover:text-accent transition-colors">Terms</a>
            <a href="/disclosure.html" className="hover:text-accent transition-colors">Affiliate Disclosure</a>
          </nav>
        </div>

        <p className="mt-8 text-xs text-ink-light/80">
          &copy; {year} Truffle Hunting Oregon. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
